import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download",
  "use": "icon-download-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 16\" id=\"icon-download\"><path d=\"M12.56,14.08H6.87C5,14,3,14,1.18,14a1,1,0,0,0-1,.7,1,1,0,0,0,.49,1.11A1,1,0,0,0,1,16H12.9A1,1,0,0,0,14,15.12,1,1,0,0,0,13.14,14a1,1,0,0,0-.53.09Zm.88-8.75a1.06,1.06,0,0,0-1.47.1C10.69,6.74,9.42,7.94,8.14,9.25c-.1,0-.1.1-.2.2h-.1V.94A1.2,1.2,0,0,0,7.72.5,1,1,0,0,0,6.38.14h0A.87.87,0,0,0,5.89,1V9.55c-.1-.1-.2-.1-.2-.2C4.51,8.29,3.44,7,2.26,6l-.59-.6a1,1,0,0,0-1.37.1l-.1.1a.87.87,0,0,0,.1,1.21h0L.59,7C2.45,9,4.32,10.76,6.28,12.47a1,1,0,0,0,1.47,0l.2-.2c1.47-1.51,2.94-2.92,4.41-4.43l1.18-1.21a1,1,0,0,0-.1-1.27Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/download.svg
// module id = 280
// module chunks = 0 1